<template>
    <div>
        <h2>{{ $t("settings.smart-routing.keywords.header") }}</h2>

        <b-form-group
            id="fieldset-keyword-match-mode"
            :description="$t('settings.smart-routing.keywords.match-mode.description')"
            :label="$t('settings.smart-routing.keywords.match-mode.label')"
            content-cols-lg="7"
            content-cols-sm
            label-cols-lg="3"
            label-cols-sm="4"
        >
            <b-form-radio-group
                id="contact-keyword-mode-radio"
                v-model="currentRoute.keywordMode"
                :options="availableModes"
                button-variant="light"
                buttons
                name="contact-keyword-mode-radio"
            ></b-form-radio-group>
        </b-form-group>
        <b-form-group
            id="fieldset-keywords"
            :description="$t('settings.smart-routing.keywords.keywords.description')"
            :label="$t('settings.smart-routing.keywords.keywords.label')"
            content-cols-lg="7"
            content-cols-sm
            label-cols-lg="3"
            label-cols-sm="4"
        >
            <b-form-tags
                v-model="currentRoute.keywordStrings"
                :add-button-text="$t('settings.smart-routing.keywords.keywords.add')"
                :placeholder="$t('settings.smart-routing.keywords.keywords.placeholder')"
                add-button-variant="secondary"
                input-id="tags-basic"
                tag-variant="primary"
            />
        </b-form-group>
        <!--        <b-form-group-->
        <!--            id="fieldset-messages-checked"-->
        <!--            :description="$t('settings.smart-routing.keywords.messages-checked.description')"-->
        <!--            :label="$t('settings.smart-routing.keywords.messages-checked.label')"-->
        <!--            content-cols-lg="7"-->
        <!--            content-cols-sm-->
        <!--            label-cols-lg="3"-->
        <!--            label-cols-sm="4"-->
        <!--        >-->
        <!--            <b-form-radio-group-->
        <!--                v-if="!currentRoute.afterTemplate"-->
        <!--                id="messages-checked-radio"-->
        <!--                v-model="currentRoute.amountOfMessages"-->
        <!--                :options="availableAmountOfMessages"-->
        <!--                button-variant="light"-->
        <!--                buttons-->
        <!--                name="messages-checked-radio"-->
        <!--            ></b-form-radio-group>-->
        <!--            <label v-else>-->
        <!--                {{ $tc("settings.smart-routing.keywords.messages-checked.amount", 1) }}-->
        <!--            </label>-->
        <!--        </b-form-group>-->
    </div>
</template>
<script>
import { BFormGroup, BFormInput, BFormTags, BFormRadioGroup } from "bootstrap-vue";
import { ValidationProvider } from "vee-validate";
import { watchEffect } from "@vue/composition-api";
import i18n from "@/libs/i18n";
import useRoutes from "@/views/modules/settings/smart-routing/useRoutes";

export default {
    components: {
        BFormGroup,
        BFormInput,
        BFormTags,
        BFormRadioGroup,
        ValidationProvider,
    },
    setup() {
        const { currentRoute } = useRoutes();
        const availableModes = [
            {
                text: i18n.t("settings.smart-routing.match-mode.one"),
                value: "OR",
            },
            {
                text: i18n.t("settings.smart-routing.match-mode.all"),
                value: "AND",
            },
        ];
        const availableAmountOfMessages = [
            {
                value: "1",
                text: i18n.tc("settings.smart-routing.keywords.messages-checked.amount", 1),
            },
            {
                value: "2",
                text: i18n.tc("settings.smart-routing.keywords.messages-checked.amount", 2),
            },
            {
                value: "3",
                text: i18n.tc("settings.smart-routing.keywords.messages-checked.amount", 3),
            },
        ];
        watchEffect(() => {
            if (currentRoute.value.keywords) {
                currentRoute.value.keywordStrings = currentRoute.value.keywords.map((keyword) => keyword.keyword);
            }
        });

        return {
            availableModes,
            availableAmountOfMessages,
            currentRoute,
        };
    },
};
</script>
